import React from 'react';
import type { ScenarioAssetLayer } from '../../systems/scenario-asset-url';
import styles from './scenario-studio.module.css';

interface PreviewAssetLayerToggleProps {
  value: ScenarioAssetLayer;
  onChange: (layer: ScenarioAssetLayer) => void;
  disabled?: boolean;
  className?: string;
}

export const PreviewAssetLayerToggle: React.FC<PreviewAssetLayerToggleProps> = ({
  value,
  onChange,
  disabled = false,
  className,
}) => (
  <div
    className={`${styles.previewLayerToggle}${className ? ` ${className}` : ''}`}
    role="group"
    aria-label="Couche d'assets pour l'aperçu"
    title="Assets servis depuis le brouillon (draft) ou la version publiée (master)"
  >
    <button
      type="button"
      className={`${styles.btnSecondary} ${value === 'draft' ? styles.tabActive : ''}`}
      onClick={() => onChange('draft')}
      disabled={disabled}
      aria-pressed={value === 'draft'}
    >
      Draft
    </button>
    <button
      type="button"
      className={`${styles.btnSecondary} ${value === 'master' ? styles.tabActive : ''}`}
      onClick={() => onChange('master')}
      disabled={disabled}
      aria-pressed={value === 'master'}
    >
      Master
    </button>
  </div>
);
